import { Injectable } from '@angular/core';
import { DeviceModel } from '../models/device.model';

@Injectable({
    providedIn: 'root'
})

export class GlobalService {
    /**
     * Number of new notifications
     */
    public notificationCount = 0;
    /**
     * Check if dialog logout is active or not. This variable is needed to avoid system to have
     * multiple calls to LogoutSession in LogoutService.
     */
    public isLogoutDialogActive = false;
    /**
     * Platform of device either native (iOS and android) or web
     */
    public devicePlatform = "web";

    public deviceModel: Partial<DeviceModel>;

    public patgRegStatusId: number;

    public registration = false;

    constructor() { }
}
